// extracted by mini-css-extract-plugin
export default {"List":"LawLibrary_List__JSUsO","TableWrapper":"LawLibrary_TableWrapper__ABOt9"};